var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProjects = function SvgProjects(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C2.35503 2 1 3.35503 1 5V14C1 15.645 2.35503 17 4 17H5V18V19H5.41602C5.85942 20.1067 6.74338 21 8 21H23V7H21V19H8C7.43497 19 7 18.565 7 18V17H19V4H7V2H4ZM4 4H5V11H4C3.61165 11 3.34201 11.279 3 11.416V5C3 4.43497 3.43497 4 4 4ZM7 6H17V15H4C3.43497 15 3 14.565 3 14C3 13.435 3.43497 13 4 13H7V6ZM11 8L12.293 9.29297L11 10.5859L9.70703 9.29297L8.29297 10.707L11 13.4141L13.707 10.707L15 12V8H11Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProjects, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Projects.df74365e.svg";
export { ForwardRef as ReactComponent };